<template>
  <div id="conviction-page" class='conviction-home-component'>

    <div class='conviction-top-container'>
    </div>

    <div class="triangle-left"/>
    <div class="triangle-rigth"/>

    <div class='conviction-bottom-container'>
      <div fade class='conviction-title'>NOS CONVICTIONS</div>
      <div fade class='conviction-underline'></div>

      <div fade class='conviction-details-container'>
        <div class='conviction-detail-container' v-for='conviction in convictions' :key='conviction.id'>
          <div class='conviction-detail-border'>
            <div class='conviction-image-container' :style="{'--icon-step':conviction.iconStep, '--animation-duration':conviction.animationDuration+'s', '--icon-last-position':-conviction.iconStep*64+'px'}">
              <div class="image" :style="{'background-image':`url(${conviction.icon})`}"/>
            </div>
            <div class='conviction-text-container'>
              <p>{{ conviction.text }}</p>
            </div>
          </div>
        </div>
      </div>
      <div fade class='conviction-bottom-text-container'>
        <div class='conviction-bottom-text'>
          C'est ce goût du travail bien fait qui nous donne envie de partager nos connaissances !
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'ConvictionHomeComponent',

  props: ['controller', 'convictions'],

  methods: {
    initPageScene () {
      const pageSelector = '#conviction-page'

      gsap.set(pageSelector, { autoAlpha: 0 })
      gsap.to(pageSelector, {
        duration: 1,
        autoAlpha: 1,
        scrollTrigger: {
          trigger: pageSelector,
          start: 'top 95%'
        }
      })
    },

    initContentScene () {
      const fades = this.$el.querySelectorAll('[fade]')
      gsap.set(fades, { autoAlpha: 0, y: 200 })

      gsap.to(fades, {
        duration: 0.8,
        autoAlpha: 1,
        y: '-=100',
        stagger: 0.2,
        scrollTrigger: {
          trigger: '#conviction-page',
          start: 'top center'
        }
      })

      gsap.to('.conviction-bottom-container', {
        y: '-=200',
        ease: 'none',
        scrollTrigger: {
          trigger: '#conviction-page',
          start: 'top center',
          end: '+=' + (typeof window !== 'undefined' ? window.innerHeight : 1000),
          scrub: true
        }
      })
    }
  },

  mounted () {
    gsap.set('.triangle-left, .triangle-rigth', { borderBottomWidth: 0, borderTopWidth: 0, bottom: 0 })

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '#conviction-page',
        start: 'top 10%',
        scrub: true
      }
    })
      .to('.triangle-left', { duration: 2, borderBottomWidth: 100, bottom: -98 }, 'b')
      .to('.triangle-rigth', { duration: 2, borderTopWidth: 100, bottom: -98 }, 'b')

    /* eslint no-unused-expressions: 0 */
    tl

    this.initPageScene()
    this.initContentScene()
  }

}
</script>

<style lang='scss' scoped>
$arrow-down: polygon(100% 0%, 100% 90%, 50% 100%, 0 90%, 0 0%);

.conviction-home-component {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding: 0 64px 84px;
  background-color: #06326C;
  box-sizing: border-box;

  position: relative;

  height: 70vh;
  min-height: calc((1080px / 100) * 70);

  @include media(phone) {
    padding: 0 32px 0;
    display: flex;
    grid-template-columns: unset;
    grid-template-rows: unset;
    height: unset;
  }

  .conviction-top-container {
    position: absolute;

    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-size: contain;
    background-repeat: no-repeat;

    background-image: url('../../assets/Image-code.png');
    background-position-y: -56px;

    @include media(phone) {
      max-height: 25%;
      background-size: cover;
      background-position: center;
    }

  }

  .conviction-bottom-container {
    display: flex;
    flex-direction: column;

    max-width: 1400px;
    width: 100%;

    @include media(phone) {
      padding: 10px 32px;
      margin-top: 256px;
      margin-bottom: 0;
    }

    .conviction-title {
      @extend %default-title;
      color: #FFFFFF;
    }

    .conviction-underline {
      @extend %default-underline;
      border-color: white;
    }

    .conviction-details-container {
      align-items: center;
      display: flex;
      grid-column: 1;
      grid-row: 2;
      height: 75%;
      justify-content: space-between;

      @include media(phone) {
        flex-direction: column;
        margin: 0 6px;
      }

      .conviction-detail-container {
        display: flex;
        justify-content: center;
        align-items: center;

        background-color: #306AB9;
        border-radius: 2px;
        box-shadow: 0 2px 8px 0 rgba(129,129,129,0.5);
        color: #FFFFFF;
        height: 90%;
        text-align: center;
        width: 22%;
        height: 200px;

        @include media(phone) {
          width: 100%;
          margin: 16px 0;
        }

        user-select: none;

        .conviction-detail-border {
          border: 1px solid #FFFFFF;
          height: 90%;
          opacity: 0.8;
          width: 92%;

          .conviction-image-container {
            height: 64px;
            margin: 0px auto;
            padding-top: 12%;
            width: 64px;
            @keyframes play {
              100% { background-position: var(--icon-last-position); }
            }
            .image {
              background-size: cover;
              background-repeat: no-repeat;
              background-position: left center;
              height: 100%;
              animation: play var(--animation-duration) steps(var(--icon-step)) infinite;
            }
            img {
              width: 100%;
            }
          }

          .conviction-text-container {
            margin-top: 15%;
            width: 100%;
          }
        }
      }
    }

    .conviction-bottom-text-container {
      display: flex;
      justify-content: center;
      letter-spacing: 0.08px;
      line-height: 34px;
      margin-top: 68px;
      margin-left: 4px;
      margin-right: 4px;

      text-align: center;

      .conviction-bottom-text {
        color: #FFFFFF;
        font-weight: 300;
        font-size: 18px;
        line-height: 24px;
      }
    }
  }
}

.triangle {
  position: absolute;
  bottom: -100px;
  width: 0;
  height: 0;
  border-style: solid;
}

.triangle-left {
  @extend .triangle;

  right: 50%;
  border-width: 0 960px 100px 0;
  border-color: transparent #06326C transparent transparent;
}

.triangle-rigth {
  @extend .triangle;

  left: 50%;
  border-width: 100px 960px 0 0;
  border-color: #06326C transparent transparent transparent;
}

</style>
